/**
 * Admin console contract (ADR-20), organised by bounded domain. Each domain
 * owns its schemas and its slice of the manifest; `adminRoutes` is the single
 * aggregate the API controllers (`@Contract`) and the admin app's
 * `createClient({ admin: adminRoutes })` are written against.
 *
 * Adding an endpoint: add the schema + route entry in its domain, nothing else.
 */
import { adminMarriageRoutes } from './marriage/routes.js';
export * from './marriage/routes.js';
import { adminAuthRoutes } from './auth/routes.js';
import { adminAdminsRoutes } from './admins/routes.js';
import { adminRolesRoutes } from './roles/routes.js';
import { adminModerationRoutes } from './moderation/routes.js';
import { adminAppealsRoutes } from './appeals/routes.js';
import { adminSubscriptionsRoutes } from './subscriptions/routes.js';
import { adminMembersRoutes } from './members/routes.js';
import { adminPaymentsRoutes } from './payments/routes.js';
import { adminSupportRoutes } from './support/routes.js';
import { adminContentRoutes } from './content/routes.js';
import { adminAnalyticsRoutes } from './analytics/routes.js';
import { adminOnboardingRoutes } from './onboarding/routes.js';
export * from './shared.js';
export * from './auth/schemas.js';
export * from './auth/routes.js';
export * from './admins/schemas.js';
export * from './admins/routes.js';
export * from './roles/schemas.js';
export * from './roles/routes.js';
export * from './moderation/schemas.js';
export * from './moderation/routes.js';
export * from './appeals/schemas.js';
export * from './appeals/routes.js';
export * from './subscriptions/schemas.js';
export * from './subscriptions/routes.js';
export * from './members/schemas.js';
export * from './members/routes.js';
export * from './payments/schemas.js';
export * from './payments/routes.js';
export * from './support/schemas.js';
export * from './support/routes.js';
export * from './content/schemas.js';
export * from './content/routes.js';
export * from './analytics/schemas.js';
export * from './analytics/routes.js';
export * from './onboarding/routes.js';
// The RBAC matrix imports `typeof adminRoutes` from this module; the cycle is
// type-only, so it is erased at runtime and safe under CJS.
export * from './rbac.js';
export const adminRoutes = {
    ...adminMarriageRoutes,
    ...adminAuthRoutes,
    ...adminAdminsRoutes,
    ...adminRolesRoutes,
    ...adminModerationRoutes,
    ...adminAppealsRoutes,
    ...adminSubscriptionsRoutes,
    ...adminMembersRoutes,
    ...adminPaymentsRoutes,
    ...adminSupportRoutes,
    ...adminContentRoutes,
    ...adminAnalyticsRoutes,
    ...adminOnboardingRoutes,
};
//# sourceMappingURL=index.js.map